import { render, staticRenderFns } from "./host-common-message.vue?vue&type=template&id=43bf4eba&scoped=true&"
import script from "./host-common-message.vue?vue&type=script&lang=js&"
export * from "./host-common-message.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "43bf4eba",
  null
  
)

export default component.exports